import React, { useId } from 'react';

/**
 * A soft abstract shape for page backgrounds, drawn in the theme's primary and
 * secondary colours. Replaces decorations that used the product's logo, so the
 * backgrounds suit every product and every client.
 *
 * Same 43:29 proportions as the images it replaced, so layouts are unchanged;
 * size and position come from `className`.
 */
export const DecorativeShape: React.FC<{ className?: string }> = ({ className = '' }) => {
  const id = useId().replace(/:/g, '');

  return (
    <svg viewBox="0 0 43 29" className={className} aria-hidden="true" focusable="false">
      <defs>
        <linearGradient id={`${id}-fill`} x1="0" y1="0" x2="43" y2="29" gradientUnits="userSpaceOnUse">
          <stop offset="0" style={{ stopColor: 'rgb(var(--kv-agentic-blue, 54 131 198))' }} />
          <stop offset="1" style={{ stopColor: 'rgb(var(--kv-agentic-purple, 128 93 198))' }} />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="26" height="27" rx="13" fill={`url(#${id}-fill)`} />
      <circle cx="33.5" cy="9" r="8" fill={`url(#${id}-fill)`} opacity="0.75" />
      <circle cx="35" cy="23" r="5" fill={`url(#${id}-fill)`} opacity="0.5" />
    </svg>
  );
};
